const Styles = {
  dropdownView: {
    width: '100%',
    mb: 2,
  },
};

export default Styles;
